document.addEventListener("DOMContentLoaded", () => {
  const productForm = document.querySelector("#bzProductForm");
  if (!productForm) return;

  const formHost = productForm.closest("product-form-component");
  const optionButtons = productForm.querySelectorAll(".bz-option-btn");
  const optionGroups = productForm.querySelectorAll(".bz-option-group");

  const modal = document.querySelector("[data-bz-pdp-selection-modal]");
  const modalMessage = document.querySelector("[data-bz-pdp-selection-modal-message]");
  const modalCloseEls = document.querySelectorAll("[data-bz-pdp-selection-modal-close]");

  function parseRequiredOptionPositions() {
    if (!formHost) return [];

    try {
      const counts = JSON.parse(formHost.dataset.bzOptionCounts || "[]");
      const requiredPositions = [];

      counts.forEach((count, index) => {
        if (Number(count) > 1) {
          requiredPositions.push(String(index + 1));
        }
      });

      return requiredPositions;
    } catch (error) {
      return [];
    }
  }

  function initializeExplicitSelectionState() {
    const requiredPositions = parseRequiredOptionPositions();

    optionGroups.forEach(group => {
      const position = String(group.dataset.optionPosition || "");

      if (requiredPositions.includes(position)) {
        group.dataset.userSelected = "false";
      } else {
        group.dataset.userSelected = "true";
      }
    });
  }

  function getMissingRequiredGroups() {
    const requiredPositions = parseRequiredOptionPositions();

    return Array.from(optionGroups).filter(group => {
      const position = String(group.dataset.optionPosition || "");
      if (!requiredPositions.includes(position)) return false;

      return group.dataset.userSelected !== "true";
    });
  }

  function getFriendlyOptionName(group) {
    const rawName = String(group?.dataset?.optionName || "").toLowerCase();

    if (rawName.includes("size")) return "size";
    if (rawName.includes("color") || rawName.includes("colour")) return "color";

    return rawName || "option";
  }

  function buildMissingMessage(missingGroups) {
    const names = missingGroups
      .map(getFriendlyOptionName)
      .filter(Boolean);

    const uniqueNames = [...new Set(names)];

    const hasSize = uniqueNames.includes("size");
    const hasColor = uniqueNames.includes("color");

    if (hasSize && hasColor) {
      return "Please choose your size and color before adding to cart.";
    }

    if (hasSize) {
      return "Please choose your size before adding to cart.";
    }

    if (hasColor) {
      return "Please choose your color before adding to cart.";
    }

    if (uniqueNames.length === 1) {
      return `Please choose your ${uniqueNames[0]} before adding to cart.`;
    }

    return "Please choose your options before adding to cart.";
  }

  function openSelectionModal(message) {
    if (!modal) return;

    if (modalMessage) {
      modalMessage.textContent = message;
    }

    modal.hidden = false;
    document.documentElement.classList.add("bz-pdp-modal-open");
  }

  function closeSelectionModal() {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove("bz-pdp-modal-open");
  }

  modalCloseEls.forEach(el => {
    el.addEventListener("click", closeSelectionModal);
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape") {
      closeSelectionModal();
    }
  });

  function scrollToFirstMissingGroup(missingGroups) {
    const firstGroup = missingGroups[0];
    if (!firstGroup) return;

    firstGroup.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  function showSelectionError(missingGroups, shouldScroll) {
    const message = buildMissingMessage(missingGroups);

    const liveRegion =
      formHost?.querySelector('[ref="liveRegion"]') ||
      formHost?.querySelector("[aria-live]");

    if (liveRegion) {
      liveRegion.textContent = message;
    }

    if (shouldScroll) {
      scrollToFirstMissingGroup(missingGroups);
    }

    openSelectionModal(message);
  }

  function guardRequiredSelections(shouldScroll) {
    const missingGroups = getMissingRequiredGroups();

    if (!missingGroups.length) {
      return true;
    }

    showSelectionError(missingGroups, shouldScroll);
    return false;
  }

  function updateSelectedVariant(form) {
    const selectedOptions = [];

    form.querySelectorAll(".bz-option-group").forEach(group => {
      const active = group.querySelector(".bz-option-btn.is-selected");

      if (active) {
        selectedOptions.push(active.dataset.optionValue);
      }
    });

    const variants = window.productVariants || [];

    const variant = variants.find(v =>
      JSON.stringify(v.options) === JSON.stringify(selectedOptions)
    );

    if (variant) {
      const input = form.querySelector('input[name="id"]');

      if (input) {
        input.value = variant.id;
      }
    }
  }

  initializeExplicitSelectionState();

  optionButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const form = btn.closest("form");
      const buttonGroup = btn.closest(".bz-option-buttons");
      const optionGroup = btn.closest(".bz-option-group");

      if (!form || !buttonGroup || !optionGroup) return;

      buttonGroup.querySelectorAll(".bz-option-btn").forEach(b => {
        b.classList.remove("is-selected");
        b.setAttribute("aria-pressed", "false");
      });

      btn.classList.add("is-selected");
      btn.setAttribute("aria-pressed", "true");

      optionGroup.dataset.userSelected = "true";

      updateSelectedVariant(form);

      form.dispatchEvent(
        new CustomEvent("bz:option-explicitly-selected", {
          bubbles: true,
          detail: {
            optionPosition: optionGroup.dataset.optionPosition || null,
            optionName: optionGroup.dataset.optionName || null,
            optionValue: btn.dataset.optionValue || null
          }
        })
      );
    });
  });

  productForm.addEventListener(
    "submit",
    event => {
      const canSubmit = guardRequiredSelections(false);

      if (!canSubmit) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  const mainATC = document.querySelector("#bzProductForm .add-to-cart-button");
  const sticky = document.querySelector(".bz-sticky-atc");
  const stickyBtn = sticky ? sticky.querySelector("button") : null;

  if (mainATC) {
  mainATC.addEventListener(
    "click",
    event => {
      const canSubmit = guardRequiredSelections(false);

      if (!canSubmit) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

  if (mainATC && sticky && stickyBtn) {
    function updateStickyVisibility() {
      const rect = mainATC.getBoundingClientRect();

      if (rect.bottom < 0) {
        sticky.classList.add("bz-sticky-visible");
      } else {
        sticky.classList.remove("bz-sticky-visible");
      }
    }

    window.addEventListener("scroll", updateStickyVisibility, { passive: true });
    window.addEventListener("resize", updateStickyVisibility);
    updateStickyVisibility();

    stickyBtn.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();

      const canSubmit = guardRequiredSelections(true);

      if (!canSubmit) return;

      productForm.requestSubmit();
    });
  }
});

document.addEventListener("submit", function(e) {
  if (!e.target.closest("#bzProductForm")) return;

  setTimeout(function() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, 120);
});